export default __webpack_public_path__ + "static/media/equipment.e31f17b1.svg";